"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckoutStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const i18n_1 = require("../../common/i18n");
exports.useCheckoutStore = (0, pinia_1.defineStore)('checkoutStore', {
    state: () => ({
        shippingModes: [],
        shippingAddresses: {
            personalPickupPointAddress: null,
            pickupPointAddresses: [],
            customerAddresses: [],
            customAddressAllowed: false
        },
        paymentModes: [],
        extraFees: null,
        glsFlexDeliveryFormSubmitted: false,
        customAddressFormSubmitted: false
    }),
    getters: {
        shippingModeOptions: (state) => {
            return state.shippingModes.map((shippingMode) => {
                return new Option_1.default(shippingMode.id, i18n_1.Translator.trans(`shipping_mode_${shippingMode.id}`, shippingMode.name, 'checkout'), false);
            });
        },
        pickupPointAddressesOptions: (state) => {
            return state.shippingAddresses.pickupPointAddresses.map((pickUpPointAddress) => {
                return new Option_1.default(pickUpPointAddress.id, pickUpPointAddress.name, false);
            });
        },
        customerAddressesOptions: (state) => {
            return state.shippingAddresses.customerAddresses.map((customerAddress) => {
                return new Option_1.default(customerAddress.id, customerAddress.name, false);
            });
        },
        paymentModeOptions: (state) => {
            return state.paymentModes.map((paymentMode) => {
                return new Option_1.default(paymentMode.id, i18n_1.Translator.trans(`payment_mode_${paymentMode.id}`, paymentMode.name, 'checkout'), false);
            });
        }
    },
    actions: {
        async getShippingModes(router, { cartId }) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_checkout_shipping_modes', params: { id: cartId } }).href, { method: 'GET' });
                this.shippingModes = response;
            }
            catch (error) {
                console.error('Error in getShippingModes:', error);
                throw error;
            }
        },
        async getShippingAddresses(router, { cartId }) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_checkout_shipping_addresses', params: { id: cartId } }).href, { method: 'GET' });
                this.shippingAddresses = response;
            }
            catch (error) {
                console.error('Error in getShippingAddresses:', error);
                throw error;
            }
        },
        async getPaymentModes(router, { cartId, shippingId, cartCurrency, customAddress = false }) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({
                    name: 'shop_checkout_payment_modes',
                    params: { id: cartId },
                    //@ts-ignore
                    query: { "shippingId": shippingId, "cartCurrency": cartCurrency, "customAddress": customAddress }
                }).href, { method: 'GET' });
                this.paymentModes = response;
            }
            catch (error) {
                console.error('Error in getPaymentModes:', error);
                throw error;
            }
        },
        resetPaymentModes() {
            this.paymentModes = [];
        },
        async getExtraFees(router, { cartId, customAddress = false, shippingModeId = null, paymentModeId = null }) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({
                    name: 'shop_checkout_extra_fees',
                    params: { id: cartId },
                    //@ts-ignore
                    query: { "customAddress": customAddress, "shippingModeId": shippingModeId, "paymentModeId": paymentModeId }
                }).href, { method: 'GET' });
                this.extraFees = response;
            }
            catch (error) {
                console.error('Error in getExtraFees:', error);
                throw error;
            }
        },
        resetExtraFees() {
            this.extraFees = null;
        },
        setGlsFormSubmitted(submitted) {
            this.glsFlexDeliveryFormSubmitted = submitted;
        },
        setCustomAddressFormSubmitted(submitted) {
            this.customAddressFormSubmitted = submitted;
        },
        //TODO put into an own order module, but the order name reserved for axapta order queries
        async sendOrder(router, createOrderRequest) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_checkout_create_order' }).href, {
                    method: 'POST',
                    body: JSON.stringify(createOrderRequest),
                    headers: {
                        'Accept': 'application/json'
                    }
                });
                return response;
            }
            catch (error) {
                console.error('Error in sendOrder:', error);
                throw error;
            }
        }
    }
});
